export default "__VITE_ASSET__DnSH7LPq__"